import { PaymentTypes } from "../../common/Enums";

interface Props
{
    onGetRedsysData: (paymentTypeId: number) => any,
    totalPrice: number,
    title: string,
    style?:any
}

export default function PayWithCardRedsys(props: Props)
{
    async function onPayClick(){
        let data = await props.onGetRedsysData(PaymentTypes.CardWeb);
        paymentCardStart(data.redsys);
    }

    function createElementInput(name:string,value:string){
        let doc = document.createElement("input");
        doc.name = name;
        doc.value = value;
        return doc;
    }

    async function paymentCardStart(data:any){
        let form = document.createElement("form");
        form.className="hidden"
        form.method = "POST";
        form.action = data.apiRedsys;
        form.appendChild(createElementInput('Ds_SignatureVersion',data.dsSignatureVersion));
        form.appendChild(createElementInput('Ds_MerchantParameters',data.dsMerchantParameters));
        form.appendChild(createElementInput('Ds_Signature',data.dsSignature));
        document.body.appendChild(form);
        form.submit();
    }

    return (<div className="text-center">
        <button className="btn btn-warning btn-pay btn-pay-cart" style={props.style}
            onClick={onPayClick}><i className="fas fa-credit-card mr-2" />
            {props.title}
        </button>
    </div>
    )
}